<template>
  <a-upload
    :action="action"
    accept="image/*"
    :fileList="fileList"
    listType="picture-card"
    :remove="handleRemove"
    @preview="handlePreview"
    @change="handleChange"
    :beforeUpload="beforeUpload"
  >
    <div v-if="fileList.length < 10 && seenote === false">
      <a-icon type="plus"/>
      <div class="ant-upload-text">上传图片</div>
    </div>
  </a-upload>
</template>

<script>
export default {
  name: 'UploadPicture',
  props: ['value', 'seenote'],
  data () {
    return {
      fileList: [],
      imgList: [],
      timestamp: new Date().getTime(),
      canupload: true,
      action:
        process.env.NODE_ENV === 'production'
          ? '/file/upload.do?timestamp=' + this.timestamp
          : '/api/file/upload.do?timestamp=' + this.timestamp
    }
  },
  watch: {
    value (imgUrl) {
      if (imgUrl) {
        if (typeof imgUrl === 'array') {
          imgUrl.map((item, index) => {
            return {
              uid: `uid${index}`,
              name: item.fileName,
              status: 'done',
              thumbUrl: item.fileFullName,
              url: item.fileFullName
            }
          })
        }
        if (typeof imgUrl === 'object') {
          this.imgList = imgUrl
          this.$emit('change', this.imgList)
          var arr = []
          for (let i = 0; i < imgUrl.length; i++) {
            arr.push(
              {
                uid: imgUrl[i].id,
                name: imgUrl[i].fileName,
                status: 'done',
                thumbUrl: imgUrl[i].fileFullName,
                url: imgUrl[i].fileFullName
              }
            )
          }
          this.fileList = arr
        }
      } else {
        this.fileList = []
      }
    }
  },
  methods: {
    handleRemove (file) {
      if (this.seenote) {
        return false
      }
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      const newImgList = this.imgList.slice()
      newFileList.splice(index, 1)
      newImgList.splice(index, 1)
      this.fileList = newFileList
      // this.fileList = []
      this.$emit('change', newImgList)
    },
    handlePreview (file) {
      const h = this.$createElement
      this.$info({
        class: 'modal-preview',
        centered: true,
        width: '560px',
        content: h('img', {
          attrs: {
            width: '500px',
            src: file.url
          }
        }),
        okText: '关闭'
      })
    },
    handleChange ({ file, fileList, event }) {
      this.fileList = fileList
      if (file.status === 'done') {
        const imgInfo = file.response.data.file || {}
        if (!this.canupload) {
          fileList.splice(fileList.length - 1, 1)
          this.fileList = fileList
        } else {
          this.imgList.push(imgInfo)
        }
        this.canupload = true
        // this.fileList = [{
        //   uid: '1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   thumbUrl: imgInfo.fileFullName,
        //   url: imgInfo.fileFullName
        // }]
        this.$emit('change', this.imgList)
      }
    },
    beforeUpload (file, fileList, event) {
      // this.fileList = fileList
      const isImg = file.type.includes('image/')
      if (!isImg) {
        this.$message.error('仅能上传图片文件!')
        // this.canupload = false

        fileList.splice(fileList.length - 1, 1)
        this.fileList = fileList

        // this.fileList = []
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('图片大于10MB，无法上传!')
        // this.canupload = false

        fileList.splice(fileList.length - 1, 1)
        this.fileList = fileList

        // this.fileList = []
        return false
      }
    }
  }
}
</script>

<style lang='less'>
.modal-preview {
  .anticon-info-circle {
    display: none;
  }
  .ant-modal-confirm-content {
    margin-left: 0;
  }
}
</style>
